
    import _Handlebars from 'handlebars/runtime';

    var Handlebars = _Handlebars.default;
    import "/var/canvas/ui/shared/external-tools/jst/_external_tools_menu.handlebars";
import "@canvas/i18n";
import "@canvas/handlebars-helpers/index.js";

    var template = Handlebars.template, templates = Handlebars.templates = Handlebars.templates || {};
    var name = '/var/canvas/ui/features/quizzes-index/jst/IndexView';
    templates[name] = template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); partials = this.merge(partials, Handlebars.partials); data = data || {};
  var buffer = "", stack1, helper, options, helperMissing=helpers.helperMissing, escapeExpression=this.escapeExpression, functionType="function", self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n    <div class=\"header-bar-right\">\n      ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.create), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n      <div class=\"inline-block\">\n        <a class=\"al-trigger btn\" role=\"button\" aria-haspopup=\"true\" href=\"#\">\n          <i class=\"icon-more\" aria-hidden=\"true\"></i>\n          <span class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "quiz_settings_4e17f005", "Quiz Settings", options) : helperMissing.call(depth0, "t", "quiz_settings_4e17f005", "Quiz Settings", options)))
    + "</span>\n        </a>\n\n        <ul id=\"toolbar-1\" class=\"al-options\" role=\"menu\" tabindex=\"0\" aria-hidden=\"true\" aria-expanded=\"false\">\n          ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(7, program7, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.read_question_banks), ((stack1 = (depth0 && depth0.flags)),stack1 == null || stack1 === false ? stack1 : stack1.question_banks), options) : helperMissing.call(depth0, "ifAll", ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.read_question_banks), ((stack1 = (depth0 && depth0.flags)),stack1 == null || stack1 === false ? stack1 : stack1.question_banks), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n          ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(9, program9, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.manage), ((stack1 = (depth0 && depth0.flags)),stack1 == null || stack1 === false ? stack1 : stack1.publish_multiple), options) : helperMissing.call(depth0, "ifAll", ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.manage), ((stack1 = (depth0 && depth0.flags)),stack1 == null || stack1 === false ? stack1 : stack1.publish_multiple), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n          ";
  stack1 = (helper = helpers.ifAll || (depth0 && depth0.ifAll),options={hash:{},inverse:self.noop,fn:self.program(11, program11, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.flags)),stack1 == null || stack1 === false ? stack1 : stack1.quiz_lti_enabled), options) : helperMissing.call(depth0, "ifAll", ((stack1 = (depth0 && depth0.flags)),stack1 == null || stack1 === false ? stack1 : stack1.quiz_lti_enabled), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n          ";
  stack1 = self.invokePartial(partials['ui/shared/external-tools/jst/_external_tools_menu.handlebars'], 'ui/shared/external-tools/jst/_external_tools_menu.handlebars', (depth0 && depth0.quizIndexPlacements), helpers, partials, data);
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n        </ul>\n      </div>\n    </div>\n  ";
  return buffer;
  }
function program2(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n        ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.flags)),stack1 == null || stack1 === false ? stack1 : stack1.quiz_lti_enabled), {hash:{},inverse:self.program(5, program5, data),fn:self.program(3, program3, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n      ";
  return buffer;
  }
function program3(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <button class=\"btn btn-primary choose-quiz-engine\"\n            title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "add_quiz_cebfa28b", "Add Quiz", options) : helperMissing.call(depth0, "t", "add_quiz_cebfa28b", "Add Quiz", options)))
    + "'\n            aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "add_quiz_cebfa28b", "Add Quiz", options) : helperMissing.call(depth0, "t", "add_quiz_cebfa28b", "Add Quiz", options)))
    + "'>\n            <i class=\"icon-plus\" />&nbsp;"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "quiz_e0dcce8f", "Quiz", options) : helperMissing.call(depth0, "t", "quiz_e0dcce8f", "Quiz", options)))
    + "\n          </button>\n        ";
  return buffer;
  }

function program5(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <form class=\"new-quiz-form\" action=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.urls)),stack1 == null || stack1 === false ? stack1 : stack1.new_quiz_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" method=\"post\">\n            <input type=\"hidden\" name=\"authenticity_token\" />\n            <button class=\"btn btn-primary new-quiz-link\"\n              title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "add_quiz_cebfa28b", "Add Quiz", options) : helperMissing.call(depth0, "t", "add_quiz_cebfa28b", "Add Quiz", options)))
    + "'\n              aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "add_quiz_cebfa28b", "Add Quiz", options) : helperMissing.call(depth0, "t", "add_quiz_cebfa28b", "Add Quiz", options)))
    + "'>\n              <i class=\"icon-plus\" />&nbsp;"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "quiz_e0dcce8f", "Quiz", options) : helperMissing.call(depth0, "t", "quiz_e0dcce8f", "Quiz", options)))
    + "\n            </button>\n          </form>\n        ";
  return buffer;
  }

function program7(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n          <li role=\"presentation\">\n            <a href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.urls)),stack1 == null || stack1 === false ? stack1 : stack1.question_banks_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" class=\"icon-question\" tabindex=\"-1\" role=\"menuitem\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "quizzes.index_view.links.manage_question_banks", "Manage Question Banks", options) : helperMissing.call(depth0, "t", "quizzes.index_view.links.manage_question_banks", "Manage Question Banks", options)))
    + "\n            </a>\n          </li>\n          ";
  return buffer;
  }

function program9(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li role=\"presentation\">\n            <a href=\"#\" class=\"publish_multiple_quizzes_link icon-unpublished\" tabindex=\"-1\" role=\"menuitem\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "quizzes.index_view.links.publish_multiple_quizzes", "Publish Multiple Quizzes", options) : helperMissing.call(depth0, "t", "quizzes.index_view.links.publish_multiple_quizzes", "Publish Multiple Quizzes", options)))
    + "\n            </a>\n          </li>\n          ";
  return buffer;
  }

function program11(depth0,data) {
  
  var buffer = "", helper, options;
  buffer += "\n          <li role=\"presentation\">\n            <a href=\"#\" tabindex=\"-1\" role=\"menuitem\" class=\"reset-quiz-engine\">\n              "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "reset_quiz_engine_choice_323a40e6", "Reset quiz engine choice", options) : helperMissing.call(depth0, "t", "reset_quiz_engine_choice_323a40e6", "Reset quiz engine choice", options)))
    + "\n            </a>\n          </li>\n          ";
  return buffer;
  }

function program13(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n    ";
  stack1 = helpers['if'].call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.read_question_banks), {hash:{},inverse:self.noop,fn:self.program(14, program14, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n  ";
  return buffer;
  }
function program14(depth0,data) {
  
  var buffer = "", stack1, helper, options;
  buffer += "\n      <div class=\"header-bar-right form-inline\">\n        <a href=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.urls)),stack1 == null || stack1 === false ? stack1 : stack1.question_banks_url)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" class=\"btn view_question_banks\"\n           title='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "view_question_banks_188a9e0f", "View Question Banks", options) : helperMissing.call(depth0, "t", "view_question_banks_188a9e0f", "View Question Banks", options)))
    + "'\n           aria-label='"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "view_question_banks_188a9e0f", "View Question Banks", options) : helperMissing.call(depth0, "t", "view_question_banks_188a9e0f", "View Question Banks", options)))
    + "'>\n          "
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_inferred_key': (true),
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "view_question_banks_188a9e0f", "View Question Banks", options) : helperMissing.call(depth0, "t", "view_question_banks_188a9e0f", "View Question Banks", options)))
    + "\n        </a>\n      </div>\n    ";
  return buffer;
  }

function program16(depth0,data) {
  
  
  return "\n  <div data-view=\"no_quizzes\" class=\"item-group-condensed\"></div>\n  ";
  }

function program18(depth0,data) {
  
  
  return "\n  <div data-view=\"assignment\" class=\"item-group-condensed\"></div>\n  ";
  }

function program20(depth0,data) {
  
  
  return "\n  <div data-view=\"open\" class=\"item-group-condensed\"></div>\n  ";
  }

function program22(depth0,data) {
  
  
  return "\n  <div data-view=\"surveys\" class=\"item-group-condensed\"></div>\n  ";
  }

  buffer += "<h1 class=\"screenreader-only\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "quizzes.index_view.quizzes_title", "Quizzes", options) : helperMissing.call(depth0, "t", "quizzes.index_view.quizzes_title", "Quizzes", options)))
    + "</h1>\n<div class=\"header-bar\">\n  <div class=\"header-bar-left form-inline\">\n    <label class=\"hidden-inline-text\" for=\"searchTerm\">"
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "quizzes.index_view.search_for_quiz", "Search for Quiz", options) : helperMissing.call(depth0, "t", "quizzes.index_view.search_for_quiz", "Search for Quiz", options)))
    + "</label>\n    <input id=\"searchTerm\" placeholder=\""
    + escapeExpression((helper = helpers.t || (depth0 && depth0.t),options={hash:{
    'i18n_scope': ("quizzes.index_view")
  },data:data},helper ? helper.call(depth0, "quizzes.index_view.search_for_quiz", "Search for Quiz", options) : helperMissing.call(depth0, "t", "quizzes.index_view.search_for_quiz", "Search for Quiz", options)))
    + "\" value=\"\" type=\"search\" />\n  </div>\n\n  ";
  stack1 = (helper = helpers.ifAny || (depth0 && depth0.ifAny),options={hash:{},inverse:self.program(13, program13, data),fn:self.program(1, program1, data),data:data},helper ? helper.call(depth0, ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.create), ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.manage), options) : helperMissing.call(depth0, "ifAny", ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.create), ((stack1 = (depth0 && depth0.permissions)),stack1 == null || stack1 === false ? stack1 : stack1.manage), options));
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n\n<div id=\"direct-share-mount-point\" />\n<div id=\"external-tool-mount-point\" />\n<div id=\"quiz-modal-mount-point\" />\n\n<div class=\"item-group-container\">\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasNoQuizzes), {hash:{},inverse:self.noop,fn:self.program(16, program16, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasAssignmentQuizzes), {hash:{},inverse:self.noop,fn:self.program(18, program18, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasOpenQuizzes), {hash:{},inverse:self.noop,fn:self.program(20, program20, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n\n  ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.hasSurveys), {hash:{},inverse:self.noop,fn:self.program(22, program22, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</div>\n";
  return buffer;
  });
    ;
    ;
    export default templates[name];
  